import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [stats, setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try { const { data } = await api.get('/admin/stats'); setStats(data.stats); }
    catch {} finally { setLoading(false); }
  };

  const MODULES = [
    { icon:'', label:'Crop Management',   desc:'View, filter, change status, export',   path:'/admin/crops',   color:'var(--primary)' },
    { icon:'🏞️', label:'Land Management',   desc:'Verify, approve/reject listings',       path:'/admin/land',    color:'#166534' },
    { icon:'👥', label:'User Management',   desc:'Farmers, buyers, agents — ban/activate', path:'/admin/users',   color:'#7C3AED' },
    { icon:'📦', label:'Crop Requests',     desc:'All buyer/agent requests, disputes',      path:'/admin/requests',color:'#D97706' },
    { icon:'🎧', label:'Customer Support',  desc:'Help farmers close crops, resolve issues',path:'/admin/support', color:'#2563EB' },
    { icon:'📢', label:'Notifications',     desc:'Broadcast alerts to all users',           path:'/admin/notify',  color:'#DC2626' },
    { icon:'📊', label:'Analytics',         desc:'Growth charts, location heatmaps',        path:'/admin/analytics',color:'#059669' },
  ];

  return (
    <div className="page">
      <div className="header">
        <div style={{ display:'flex', alignItems:'center', gap:'var(--sp-3)' }}>
          <div style={{ flex:1 }}>
            <div className="header__greeting">Admin Panel</div>
            <div className="header__name">ZevaZeva</div>
          </div>
          <button className="header__action" onClick={() => { logout(); navigate('/login'); }}>🚪 Logout</button>
        </div>
      </div>

      <div className="container" style={{ paddingTop:'var(--sp-4)' }}>

        {/* Stats overview */}
        {loading ? <div className="full-center"><span className="spinner spinner--lg" /></div> : stats && (
          <>
            <div className="section-title" style={{ marginBottom:'var(--sp-3)' }}>📊 Platform Overview</div>
            <div className="stats-grid stats-grid--3" style={{ marginBottom:'var(--sp-5)' }}>
              {[
                { icon:'👨‍🌾', label:'Farmers',    value: stats.users?.farmers || 0 },
                { icon:'🛒',   label:'Buyers',     value: stats.users?.buyers || 0 },
                { icon:'🤝',   label:'Agents',     value: stats.users?.agents || 0 },
                { icon:'',   label:'Total Crops', value: stats.crops?.total || 0 },
                { icon:'🟢',   label:'Ready to Sell',value: stats.crops?.ready || 0 },
                { icon:'🏞️',   label:'Land Listings',value: stats.land?.total || 0 },
                { icon:'⏳',   label:'Land Pending', value: stats.land?.pending || 0 },
                { icon:'📅',   label:'New This Week',value: stats.crops?.newThisWeek || 0 },
              ].map(s => (
                <div key={s.label} className="stat-card">
                  <div className="stat-card__icon">{s.icon}</div>
                  <div className="stat-card__value">{s.value}</div>
                  <div className="stat-card__label">{s.label}</div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Module cards */}
        <div className="section-title" style={{ marginBottom:'var(--sp-3)' }}>⚙️ Admin Modules</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'var(--sp-3)', marginBottom:'var(--sp-4)' }}>
          {MODULES.map(m => (
            <div key={m.label} className="card" style={{ cursor:'pointer', borderTop:`3px solid ${m.color}` }}
              onClick={() => navigate(m.path)}>
              <div className="card__body">
                <div style={{ fontSize:28, marginBottom:'var(--sp-2)' }}>{m.icon}</div>
                <div className="fw-semi text-base" style={{ marginBottom:4 }}>{m.label}</div>
                <div className="text-xs text-muted">{m.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick actions */}
        <div className="section-title" style={{ marginBottom:'var(--sp-3)' }}>⚡ Quick Actions</div>
        <div className="card" style={{ marginBottom:'var(--sp-4)' }}>
          {[
            { label:' View all crops needing closure', action: () => navigate('/admin/crops?status=growing') },
            { label:'👥 Recently registered users',      action: () => navigate('/admin/users') },
            { label:'📦 Open crop requests',             action: () => navigate('/admin/requests') },
            { label:'🔒 Force close a stuck crop',       action: () => navigate('/admin/crops') },
          ].map((a, i) => (
            <button key={i} className="menu-item" onClick={a.action}>
              <span className="menu-item__label">{a.label}</span>
              <span className="menu-item__arrow">›</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
